import React from "react";
import { InfoIcon } from "lucide-react";
import { audiences } from "../../data/sections";
import { SectionHeading } from "../ui/SectionHeading";
import { Sakura } from "../ui/Decor";
export function Audience() {
  return <section id="para-quien" aria-labelledby="para-quien-title" className="scroll-mt-20 bg-crema/60 py-20 md:py-28" data-id="element-2" data-mp="usfafc6fhve4">
      <div className="mx-auto max-w-6xl px-4 md:px-6" data-id="element-3" data-mp="pvfdprvgy4zo">
        <SectionHeading id="para-quien-title" eyebrow="Para quién es" title="Pensado para estudiar japonés con orden" data-id="element-4" data-mp="249ncirwjub4" />
        <ul className="mt-12 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-5" data-mp="3tcnu07ajswsa">
          {audiences.map(a => <li key={a.title} className="border-t border-pizarra/20 pt-5" data-id="element-6" data-mp="b72feo8wsa20">
              <Sakura className="h-5 w-5 text-terracota" data-id="element-7" data-mp="7335wpm1qbi5" />
              <h3 className="mt-3 font-serif text-xl font-medium leading-snug text-pizarra-deep" data-id="element-8" data-mp="1mkwjs7yd5t1w">{a.title}</h3>
              <p className="mt-2 leading-relaxed text-pizarra-soft" data-id="element-9" data-mp="1ijufvdti4stl">{a.text}</p>
            </li>)}
        </ul>
        <p className="mx-auto mt-12 flex max-w-2xl items-start gap-3 rounded-2xl bg-papel/80 px-5 py-4 text-sm leading-relaxed text-pizarra" data-id="element-10" data-mp="2wn54d55zjjx2">
          <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-pizarra-soft" aria-hidden="true" data-id="element-11" data-mp="31pdza72f4w1t" />
          Es material de estudio autónomo. El progreso requiere práctica y no reemplaza la conversación ni la exposición
          al idioma.
        </p>
      </div>
    </section>;
}